export const LABELS_DICT = {
  Address: 'Address',
  BankAccounts: 'Bank Accounts',
  CreditCards: 'Credit cards',
  EmailAddresses: 'Email addresses',
  MedicalIds: 'Medical Ids',
  IBANs: 'IBANs',
  PassportNumber: 'Passport number',
  TelephoneNumbers: 'Telephone numbers',
  DriverLicense: "Driver's license",
};

export const VIEWS = {
  INDEX: 0,
  BANK_ACCOUNTS: 1,
  CREDIT_CARDS: 2,
  EMAILS: 3,
  MEDICAL_IDS: 4,
  IBANS: 5,
  PASSPORT_NUMBER: 6,
  TELEPHONES: 7,
  DRIVER_LICENSE: 8,
};

export const INDEX_FIELDS = [
  {
    view: VIEWS.BANK_ACCOUNTS,
    label: LABELS_DICT.BankAccounts,
  },
  {
    view: VIEWS.CREDIT_CARDS,
    label: LABELS_DICT.CreditCards,
  },
  {
    view: VIEWS.EMAILS,
    label: LABELS_DICT.EmailAddresses,
  },
  {
    view: VIEWS.MEDICAL_IDS,
    label: LABELS_DICT.MedicalIds,
  },
  {
    view: VIEWS.IBANS,
    label: LABELS_DICT.IBANs,
  },
  {
    view: VIEWS.PASSPORT_NUMBER,
    label: LABELS_DICT.PassportNumber,
  },
  {
    view: VIEWS.TELEPHONES,
    label: LABELS_DICT.TelephoneNumbers,
  },
  {
    view: VIEWS.DRIVER_LICENSE,
    label: LABELS_DICT.DriverLicense,
  },
];

export const DARK_WEB_MESSAGE =
  "We'll alert you if we find any of the information listed below on the dark websites we monitor.";

export const ACCOUNT_TYPES_DICT = {
  '1': 'Bank Account',
  '2': 'Credit Card',
  '3': 'Debit Card',
};

export const PRIMARY_EMAIL_LABEL = 'EmailAddress';
